// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2ZwJn","main":"App_main__2vFil","resMenu":"App_resMenu__1jv6c"};